import { render, staticRenderFns } from "./mainSponsor.vue?vue&type=template&id=2fe524fa&scoped=true&"
import script from "./mainSponsor.vue?vue&type=script&lang=js&"
export * from "./mainSponsor.vue?vue&type=script&lang=js&"
import style0 from "./mainSponsor.vue?vue&type=style&index=0&id=2fe524fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe524fa",
  null
  
)

export default component.exports